import { useState, useEffect } from "react";
import { APIGet } from '../../API/APIRequest';
import "./RelatedOffers.scss";

export default function RelatedOffers({ offerId }) {
    const [relatedOffers, setRelatedOffers] = useState([]);

    useEffect(() => {
        if (!offerId) return;

        APIGet({
            "controller": "product",
            "action": "getrelatedoffers",
            "environment": null,
            "identifier": offerId
        }).then((response) => {
            if (response.data?.success) {
                setRelatedOffers(response.data.relatedOffers);
            }
        }).catch(() => {
            setRelatedOffers([]);
        });
    }, [offerId]);

    if (!relatedOffers || relatedOffers.length === 0) return null;

    return (
        <div className="related-offers">
            <div className="item-container">
                <div className="border-seperator"></div>
                <div className="item-wrapper">
                    <h3 className="related-offers-heading">Other subscription options</h3>
                </div>
            </div>
            <div className="item-container related-offers-grid">
                {relatedOffers.map((offer) => (
                    <a key={offer.id} href={`/productoffer?offerId=${offer.id}`} className="related-offer-card">
                        <h4 className="related-offer-title">{offer.title}</h4>
                        {offer.productvariantname && <p className="related-offer-description">{offer.productvariantname}</p>}
                        {offer.description && <p className="related-offer-description">{offer.description}</p>}
                    </a>
                ))}
            </div>
        </div>
    );
}
